export const selectNonFloatNumberCharacters = /[^0-9.]/g;
export const selectNonDigitCharacters = /\D+/;
